module.exports = __webpack_public_path__ + "static/media/2-aldri.e82bf081.mp3";